import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeWithSecondsColumn,
    ExternalDespatchLinkColumn,
    TextColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Outbound Operator', 'outboundOperator').withWidth(100),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc').withWidth(100),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator').withWidth(100),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc').withWidth(100),
        new FilteredDateTimeWithSecondsColumn('Departure date & time', 'departureDateTime').withWidth(160),
        new FilteredDateTimeWithSecondsColumn('Arrival date & time', 'arrivalDateTime').withWidth(160),
        new FilteredNonZeroNumberColumn('Pre-advised Quantity ', 'quantityPreAdvised').withWidth(125),
        new FilteredNonZeroNumberColumn('Objected Quantity', 'quantityObjected').withWidth(125),
        new FilteredNonZeroNumberColumn('Confirmed Quantity', 'quantityConfirmed').withWidth(125),
        new FilteredTextColumn('Who', 'creationUser').withWidth(80),
        new ExternalDespatchLinkColumn(new FilteredTextColumn('Despatch ID', 'despatchId').withWidth(205)),
        new FilteredTextColumn('Status', 'status').withWidth(130),
        new FilteredNonZeroNumberColumn('ID', 'id').withWidth(100),
        new FilteredDateTimeWithSecondsColumn('Last Update Date', 'lastUpdateDate').withWidth(160),
        new DateTimeColumn('Loading date & time', 'loadingDateTime').withWidth(140),
        new TextColumn('Transport Duration', 'transportDuration'),
        new TextColumn('Message Delay', 'messageDelay'),
        new TextColumn('Age', 'age'),
      ],
    },
  ];
};
